import type { CaptureErrorContext } from "@/lib/error-tracking/capture-properties";

const BROWSER_NETWORK_FAILURE_MESSAGES = new Set([
  "Load failed",
  "Failed to fetch",
  "NetworkError when attempting to fetch resource.",
  "Error in input stream",
]);

export function isBrowserNetworkFailure(error: unknown): boolean {
  return (
    error instanceof TypeError &&
    BROWSER_NETWORK_FAILURE_MESSAGES.has(error.message)
  );
}

export function networkFailureCaptureContext(
  error: unknown,
  surface: string,
): Pick<CaptureErrorContext, "level" | "fingerprint"> {
  if (!isBrowserNetworkFailure(error)) return {};
  return {
    level: "warning",
    fingerprint: ["browser-network-failure", surface],
  };
}
